import { useState, useCallback } from 'react';

import {
    loadConversationsFromAgent,
    deleteConversationFromAgent,
} from '@/shared/services/agentChatService';

/**
 * Hook managing conversation history for the assistant page.
 * Provides a sorted list of past conversations with refresh and delete.
 */
export default function useConversationHistory() {
    const [conversations, setConversations] = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(false);

    const refresh = useCallback(async () => {
        setLoadingHistory(true);
        try {
            const all = await loadConversationsFromAgent();
            setConversations(
                all.sort((a, b) => b.lastActivity - a.lastActivity)
            );
        } catch {
            setConversations([]);
        } finally {
            setLoadingHistory(false);
        }
    }, []);

    const remove = useCallback(async (threadId) => {
        await deleteConversationFromAgent(threadId);
        setConversations((prev) => prev.filter((c) => c.threadId !== threadId));
    }, []);

    return { conversations, loadingHistory, refresh, remove };
}
